import React from 'react';
import { Provider } from 'react-redux';
import BrowserRouter from 'react-router-dom/BrowserRouter';
import StaticRouter from 'react-router-dom/StaticRouter';
import configureStore from './store/configureStore';
import * as routes from './routes';

const Router = typeof window !== 'undefined' ? BrowserRouter : StaticRouter;
const store = configureStore(typeof window !== 'undefined' ? window.__INITIAL_STATE__ : undefined); //eslint-disable-line

export default class Root extends React.Component {
  static store = store;
  static routes = routes;

  render() {
    return (
      <Provider store={ store }>
        <Router {...this.props} >
          {routes.makeRoutes()}
        </Router>
      </Provider>
    );
  }
}
;
      const elems = document.querySelectorAll('[toga=storefront]');
      [].forEach.call(elems, function(elem) {
        let props;
        try {
          props = JSON.parse(elem.getAttribute('props'));
        } catch (e) {
          props = {};
        }
        const Component = (typeof exports.default === 'undefined')
            ? module.exports
            : exports.default;
        ReactDOM.render(<Component {...props}/>, elem);
      });


// WEBPACK FOOTER //
// ./src/components/storefront/index.js